import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, Home, ArrowLeft } from 'lucide-react';

export function ErrorBoundary() {
  const error = useRouteError();
  
  console.error('Route error:', error);

  // Handle 404 errors specifically
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center justify-center mb-2">
            <AlertCircle className="h-10 w-10 text-red-500" />
          </div>
          <CardTitle className="text-center text-2xl">
            {is404 ? "Page Not Found" : "Something went wrong"}
          </CardTitle>
          <CardDescription className="text-center">
            {is404 
              ? "The page you're looking for doesn't exist or has been moved."
              : "An unexpected error has occurred. Please try again later."}
          </CardDescription>
        </CardHeader>
        
        <CardContent>
          {is404 && (
            <div className="space-y-4">
              <p className="text-center text-gray-600">
                If you're trying to access the onboarding page after signup, you can try these options:
              </p>
              <div className="flex flex-col gap-4 mt-4">
                <a href="/onboarding" className="text-center text-primary hover:underline">
                  Go to Onboarding Page
                </a>
                <a href="/dashboard" className="text-center text-primary hover:underline">
                  Go to Dashboard
                </a>
              </div>
            </div>
          )}
          {!is404 && error instanceof Error && (
            <div className="bg-gray-100 p-3 rounded text-sm font-mono overflow-auto max-h-32">
              {error.message || "Unknown error"}
            </div>
          )}
        </CardContent>
        
        <CardFooter className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
          <Button onClick={() => window.location.href = '/'}>
            <Home className="h-4 w-4 mr-2" />
            Go Home
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
} 